import { useState, useEffect } from 'react';

import { useModalContext } from '../../context/Modal';
import { FooterNavigator } from '../Footer/FooterNavigator';
import { Icon } from '../UI';

import { SvgProps } from '../UI/Icon/Icon';

export const ConfirmAction = ({
  cancelButtonClassName,
  cancelButtonName,
  cancelButtonVariant,
  confirmedSubtitle,
  confirmedTitle,
  footerClassName,
  icon,
  loading = false,
  onlyFirstStep = false,
  subtitle = '',
  saveButtonClassName,
  saveButtonVariant,
  saveButtonName,
  title = '',
  cancel,
  finish,
  save,
}: {
  cancelButtonClassName?: string;
  cancelButtonVariant?: any;
  cancelButtonName?: string;
  confirmedSubtitle?: string;
  confirmedTitle?: React.ReactNode;
  footerClassName?: string;
  icon?: SvgProps['svgName'];
  loading?: boolean;
  subtitle?: string;
  onlyFirstStep?: boolean;
  saveButtonClassName?: string;
  saveButtonVariant?: any;
  saveButtonName?: string;
  title?: string;
  cancel?(): void;
  finish?(): void;
  save(): Promise<any>;
}) => {
  const { closeModal } = useModalContext();

  const [actionConfirmed, setActionConfirmed] = useState(false);
  const [loadingState, setLoading] = useState(loading);

  useEffect(() => {
    setLoading(false);
  }, [loading]);

  const handleSave = () => {
    setLoading(true);

    if (actionConfirmed) {
      finish?.();
      closeModal();
    } else {
      save().then(() => {
        setLoading(false);
        onlyFirstStep ? closeModal() : setActionConfirmed(true);
      });
    }
  };

  return (
    <div className="flex flex-col my-12 bg-white dark:bg-grey-90">
      <Icon
        className="mx-auto mt-10 dark:bg-grey-70 rounded-full"
        fill={false}
        svgName={actionConfirmed ? 'circleCheck' : icon || 'question1'}
      />

      <div className="w-2/3 mx-auto text-center my-10 font-medium text-xl">
        {actionConfirmed ? confirmedTitle : title}
      </div>

      <div className="w-2/3 mx-auto text-grey-50 text-center">
        {actionConfirmed ? confirmedSubtitle : subtitle}
      </div>

      <FooterNavigator
        saveButtonName={actionConfirmed ? 'Ok' : saveButtonName || 'Confirm'}
        cancelButtonClassName={cancelButtonClassName}
        cancelButtonName={cancelButtonName || 'Cancel'}
        cancelButtonVariant={cancelButtonVariant}
        saveButtonVariant={saveButtonVariant}
        saveButtonClassName={saveButtonClassName}
        className={footerClassName}
        oneButton={actionConfirmed}
        loading={loadingState}
        onSave={handleSave}
        onCancel={cancel || closeModal}
      />
    </div>
  );
};
